import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { MdFileDownload } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";

const SettlementsSuper = () => {
    return (
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                        <div>
                            <h4 className="text-dark mb-1 d-flex align-items-center">
                                Settlement Management
                            </h4>
                            <p className="text-muted mb-0">
                                Handle settlement and payouts to partners efficiently
                            </p>
                        </div>

                        <div className="d-flex gap-3 mt-2 mt-md-0">
                            <button className="btn btn-outline-primary d-flex align-items-center">
                                <MdFileDownload className="me-2" size={20} />
                                Generate Report
                            </button>
                            <button className="btn btn-primary d-flex align-items-center">
                                <MdFileDownload className="me-2" size={20} />
                                Export Settlements
                            </button>
                        </div>
                    </div>

                    <TableWrapper>
                        <table className="table table-bordered align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>Settlement ID</th>
                                    <th>Partner Name</th>
                                    <th>Period</th>
                                    <th>Amount Due</th>
                                    <th>Status</th>
                                    <th>Payout Date</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><strong>S001</strong></td>
                                    <td>City Heritage Tours</td>
                                    <td>Jun 1, 2024 - Jun 30, 2024</td>
                                    <td>1250.75 USD</td>
                                    <td><span className="badge badge-paid">Paid</span></td>
                                    <td>Jul 5, 2024</td>
                                    <td className="text-center"><BsThreeDotsVertical /></td>
                                </tr>
                                <tr>
                                    <td><strong>S002</strong></td>
                                    <td>ThrillSeeker Adventures</td>
                                    <td>Jun 1, 2024 - Jun 30, 2024</td>
                                    <td>3480.50 USD</td>
                                    <td><span className="badge badge-pending">Pending</span></td>
                                    <td>N/A</td>
                                    <td className="text-center"><BsThreeDotsVertical /></td>
                                </tr>
                                <tr>
                                    <td><strong>S003</strong></td>
                                    <td>Aqua Fun Waterpark</td>
                                    <td>Jun 1, 2024 - Jun 30, 2024</td>
                                    <td>2100.00 USD</td>
                                    <td><span className="badge badge-processing">Processing</span></td>
                                    <td>N/A</td>
                                    <td className="text-center"><BsThreeDotsVertical /></td>
                                </tr>
                                <tr className="highlighted-row">
                                    <td><strong>S004</strong></td>
                                    <td>City Heritage Tours</td>
                                    <td>May 1, 2024 - May 31, 2024</td>
                                    <td>1100.20 USD</td>
                                    <td><span className="badge badge-paid">Paid</span></td>
                                    <td>Jun 5, 2024</td>
                                    <td className="text-center"><BsThreeDotsVertical /></td>
                                </tr>
                                <tr>
                                    <td><strong>S005</strong></td>
                                    <td>EcoVentures Inc.</td>
                                    <td>Jul 1, 2024 - Jul 31, 2024</td>
                                    <td>750.00 USD</td>
                                    <td><span className="badge badge-pending">Pending</span></td>
                                    <td>N/A</td>
                                    <td className="text-center"><BsThreeDotsVertical /></td>
                                </tr>
                                <tr>
                                    <td><strong>S006</strong></td>
                                    <td>The Local Corner Store</td>
                                    <td>Jun 1, 2023 - Jun 30, 2023</td>
                                    <td>4432.13 USD</td>
                                    <td><span className="badge badge-paid">Paid</span></td>
                                    <td>Jul 5, 2023</td>
                                    <td className="text-center"><BsThreeDotsVertical /></td>
                                </tr>
                                <tr>
                                    <td><strong>S007</strong></td>
                                    <td>Artisan Goods Emporium</td>
                                    <td>Jul 1, 2023 - Jul 31, 2023</td>
                                    <td>2894.48 USD</td>
                                    <td><span className="badge badge-paid">Paid</span></td>
                                    <td>Aug 5, 2023</td>
                                    <td className="text-center"><BsThreeDotsVertical /></td>
                                </tr>
                                <tr>
                                    <td><strong>S008</strong></td>
                                    <td>Luigi's Pizzeria</td>
                                    <td>Aug 1, 2023 - Aug 31, 2023</td>
                                    <td>2182.80 USD</td>
                                    <td><span className="badge badge-paid">Paid</span></td>
                                    <td>Sep 5, 2023</td>
                                    <td className="text-center"><BsThreeDotsVertical /></td>
                                </tr>
                            </tbody>
                        </table>
                    </TableWrapper>
                </div>
            </div>
        </Wrapper>
    );
};

export default SettlementsSuper;

const Wrapper = styled.div`
  .filter-box input,
  .filter-box select {
    width: 169px !important;
  }
`;

const TableWrapper = styled.div`
  .badge {
    font-size: 0.75rem;
    border-radius: 12px;
    padding: 4px 10px;
    font-weight: 500;
  }

  .badge-paid {
    background-color: rgba(25, 135, 84, 0.15);
    color: #198754;
  }

  .badge-pending {
    background-color: rgba(255, 193, 7, 0.2);
    color: #ffc107;
  }

  .badge-processing {
    background-color: rgba(13, 202, 240, 0.2);
    color: #0dcaf0;
  }

  .highlighted-row {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .table th,
  .table td {
    vertical-align: middle;
  }

  .text-center {
    text-align: center;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }

  th,
  td {
    padding: 10px 12px;
    border: 1px solid #dee2e6;
    text-align: center;
    vertical-align: middle;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
  }

  .badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
  }

  .badge.tour {
    background-color: rgba(255, 0, 150, 0.1);
    color: #d63384;
  }

  .badge.business {
    background-color: rgba(0, 123, 255, 0.1);
    color: #0d6efd;
  }

  .badge.org {
    background-color: rgba(0, 200, 150, 0.1);
    color: #20c997;
  }

  .stars {
    white-space: nowrap;
    font-size: 16px;
    color: #f4c150;
  }

  .bold {
    font-weight: bold;
    color: #007bff;
  }
`;
